export default {
  'app.settings.menuMap.basic': 'ตั้งค่าโปรไฟล์',
  'app.settings.menuMap.security': 'ตั้งค่าความปลอดภัย',
  'app.settings.menuMap.binding': 'การเชื่อมต่อบัญชี',
  'app.settings.menuMap.notification': 'การแจ้งเตือนข้อความใหม่',
  'app.settings.basic.avatar': 'รูปโปรไฟล์',
  'app.settings.basic.change-avatar': 'เปลี่ยนรูปโปรไฟล์',
  'app.settings.basic.email': 'อีเมล',
  'app.settings.basic.email-message': 'กรุณากรอกอีเมลของคุณ!',
  'app.settings.basic.nickname': 'ชื่อเล่น',
  'app.settings.basic.nickname-message': 'กรุณากรอกชื่อเล่นของคุณ!',
  'app.settings.basic.profile': 'โปรไฟล์ส่วนตัว',
  'app.settings.basic.profile-message': 'กรุณากรอกโปรไฟล์ส่วนตัวของคุณ!',
  'app.settings.basic.profile-placeholder': 'แนะนำตัวเองสั้นๆ',
  'app.settings.basic.country': 'ประเทศ/ภูมิภาค',
  'app.settings.basic.country-message': 'กรุณากรอกประเทศของคุณ!',
  'app.settings.basic.geographic': 'จังหวัดหรือเมือง',
  'app.settings.basic.geographic-message': 'กรุณากรอกข้อมูลที่อยู่ของคุณ!',
  'app.settings.basic.address': 'ที่อยู่',
  'app.settings.basic.address-message': 'กรุณากรอกที่อยู่ของคุณ!',
  'app.settings.basic.phone': 'หมายเลขโทรศัพท์',
  'app.settings.basic.phone-message': 'กรุณากรอกหมายเลขโทรศัพท์ของคุณ!',
  'app.settings.basic.update': 'อัปเดตข้อมูล',
  'app.settings.security.strong': 'แข็งแกร่ง',
  'app.settings.security.medium': 'ปานกลาง',
  'app.settings.security.weak': 'อ่อนแอ',
  'app.settings.security.password': 'รหัสผ่านบัญชี',
  'app.settings.security.password-description': 'ความแข็งแกร่งของรหัสผ่านปัจจุบัน',
  'app.settings.security.phone': 'เบอร์โทรเพื่อความปลอดภัย',
  'app.settings.security.phone-description': 'เบอร์โทรที่ผูกไว้',
  'app.settings.security.question': 'คำถามเพื่อความปลอดภัย',
  'app.settings.security.question-description':
    'ยังไม่ได้ตั้งคำถามเพื่อความปลอดภัย การตั้งค่านี้ช่วยปกป้องบัญชีของคุณได้อย่างมีประสิทธิภาพ',
  'app.settings.security.email': 'อีเมลสำรอง',
  'app.settings.security.email-description': 'อีเมลที่ผูกไว้',
  'app.settings.security.mfa': 'อุปกรณ์ MFA',
  'app.settings.security.mfa-description':
    'ยังไม่ได้ผูกอุปกรณ์ MFA หลังจากผูกแล้วจะสามารถยืนยันตัวตนแบบสองขั้นตอนได้',
  'app.settings.security.modify': 'แก้ไข',
  'app.settings.security.set': 'ตั้งค่า',
  'app.settings.security.bind': 'ผูกบัญชี',
  'app.settings.binding.taobao': 'เชื่อมต่อ Taobao',
  'app.settings.binding.taobao-description': 'ยังไม่ได้เชื่อมต่อบัญชี Taobao',
  'app.settings.binding.alxpay': 'เชื่อมต่อ Alxpay',
  'app.settings.binding.alxpay-description': 'ยังไม่ได้เชื่อมต่อบัญชี Alxpay',
  'app.settings.binding.dingding': 'เชื่อมต่อ DingTalk',
  'app.settings.binding.dingding-description': 'ยังไม่ได้เชื่อมต่อบัญชี DingTalk',
  'app.settings.binding.bind': 'เชื่อมต่อ',
  'app.settings.notification.password': 'รหัสผ่านบัญชี',
  'app.settings.notification.password-description':
    'ข้อความจากผู้ใช้อื่นจะแจ้งเตือนในรูปแบบจดหมายภายในระบบ',
  'app.settings.notification.messages': 'ข้อความระบบ',
  'app.settings.notification.messages-description':
    'ข้อความจากระบบจะแจ้งเตือนในรูปแบบจดหมายภายในระบบ',
  'app.settings.notification.todo': 'การแจ้งเตือนสิ่งที่ต้องทำ',
  'app.settings.notification.todo-description':
    'รายการสิ่งที่ต้องทำจะแจ้งเตือนในรูปแบบจดหมายภายในระบบ',
  'app.settings.open': 'เปิด',
  'app.settings.close': 'ปิด',
  'app.settings.basic.area-code': 'รหัสภูมิ',
  'app.settings.basic.area-code-message': 'กรุณากรอกรหัสภูมิของคุณ!',
  'app.settings.basic.phone-number': 'หมายเลขโทรศัพท์',
  'app.settings.basic.phone-number-message': 'กรุณากรอกหมายเลขโทรศัพท์ของคุณ!',
  'app.settings.basic.update-success': 'อัปเดตข้อมูลสำเร็จ',
  'app.settings.basic.update-information': 'อัปเดตข้อมูล',
  'app.settings.basic.display-name': 'ชื่อที่แสดง',
  'app.settings.basic.display-name-message': 'กรุณากรอกชื่อของคุณ!',
  'app.settings.basic.username': 'ชื่อผู้ใช้',
  'app.settings.basic.username-message': 'กรุณากรอกชื่อผู้ใช้ของคุณ!',
  'app.settings.basic.account-information': 'ข้อมูลบัญชี',
  'app.settings.basic.user-uid': 'รหัสผู้ใช้',
  'app.settings.basic.organization-id': 'รหัสองค์กรณ์',
  'app.settings.basic.system-role': 'บทบาทในระบบ',
  'app.settings.basic.organization-role': 'ตำแหน่งในองค์กรณ์',
  'app.settings.basic.account-status': 'สถานะบัญชี',
  'app.settings.basic.credit-type': 'ประเภทเครดิต',
  'app.settings.basic.balance': 'ยอดเหลือ',
};
